import React from 'react';
import { cloneDeep } from 'lodash';
import Validate from './Validate';

export default function (firstKey, secondKey) {
    const context = this;
    return (value, { columnIndex, rowIndex }) => {
        const subElement = (key) => {
            const val = value[key];
            const validateValue = Validate(() => {
                const min = value[firstKey];
                const max = value[secondKey];
                if (val === max) {
                    return (val > 0 && val >= min);
                }
                return (val >= 0);
            })(val);
            return {
                value: validateValue,
                props: {
                    onClick: () => {
                        const dataClone = cloneDeep(this.state.data);
                        dataClone.rows[rowIndex].editing = columnIndex;
                        context.setState({ data: dataClone, editedKey: key });
                    },
                },
            };
        };

        const leftElement = subElement(firstKey);
        const rightElement = subElement(secondKey);
        return (
            <div className="container-fluid">
                <div {...leftElement.props}>
                    {leftElement.value}
                </div>
                <div {...rightElement.props}>
                    {rightElement.value}
                </div>
            </div>
        );
    };
}
